export const PAGE_CONFIG = {
  "name": "CommonPermissionWrap",
  "children": [
    {
      name: 'CommonLogWrap',
      "config": {
        "logConfig": {
          "menuId": "",
          "pageId": "902501",
          "pageName": "paidkol",
          "extInfo": "home-studio-paidkol",
          "pagePath": "/paidkol"
        },
      },
      children: [
        {
          "name": "KolFilter",
          "props": {
            api: '/api/v2/dashboard/studio/game/kol/selector',
            selectorList: [
              "platform",
              "region_country",
              "fix_language",
              "content",
              "campaign_name",
              "channel_name",
              "format"
            ]
          },
          "children": [
            {
              "name": "KolCardService",
              "props": {
                "api": '/api/v2/dashboard/studio/game/kol/metric/list',
                "metrics": [
                  "total_cost",
                  "media_value",
                  "roi"
                ],
                "extraParams": {
                  "group_by": [
                    "date"
                  ],
                  "order_by": [{
                    "by": "date",
                    "order": "asc"
                  }],
                  "show_total": true,
                  "logical_flag": "show_total,show_full_period_data",
                },
                "dataKey": "kolCardData"
              },
              "children": [
                {
                  "name": "CardState",
                  "className": "",
                  "style": {
                    "height": "126px",
                    "marginTop": "20px"
                  },
                  "type": "layout",
                  "props": {
                    "apiGroup": [
                      "kolCardData",
                    ]
                  },
                  "children": [
                    {
                      "name": "CommonRow",
                      "className": "margin-t-10",
                      "type": "layout",
                      "style": {},
                      "props": {},
                      "children": [
                        {
                          "name": "CommonCol",
                          "className": "",
                          "type": "layout",
                          "style": {},
                          "props": {
                            "w": 8
                          },
                          "children": [
                            {
                              "name": "StudioMetricCardTrend",
                              "className": "dbh-studio-kol-card",
                              "type": "view",
                              "style": {},
                              "props": {
                                "apiDataKey": "kolCardData",
                                "config": {
                                  "metricKey": "total_cost",
                                  "titleEn": "Cost",
                                  "titleCn": "总花费",
                                  "rainbowKey": "Cost",
                                  "formatRule": "thousands2Decimal",
                                  "titleFormatRule": "bmk00",
                                  "preUnit": "$",
                                  "trendConfig": {
                                    "Day": {
                                      "metricKey": "total_cost",
                                      "reqMetricKey": "total_cost",
                                      "formatRule": "thousands2Decimal",
                                      "isCompare": false,
                                      "nameEn": "Today",
                                      "nameCn": "当天"
                                    }
                                  },
                                }
                              }
                            }
                          ]
                        },
                        {
                          "name": "CommonCol",
                          "className": "",
                          "type": "layout",
                          "style": {},
                          "props": {
                            "w": 8
                          },
                          "children": [
                            {
                              "name": "StudioMetricCardTrend",
                              "className": "dbh-studio-kol-card",
                              "type": "view",
                              "style": {},
                              "props": {
                                "apiDataKey": "kolCardData",
                                "config": {
                                  "metricKey": "media_value",
                                  "titleEn": "Media Value",
                                  "titleCn": "媒体价值",
                                  "rainbowKey": "Media Value",
                                  "formatRule": "thousands2Decimal",
                                  "titleFormatRule": "bmk00",
                                  "preUnit": "$",
                                  "trendConfig": {
                                    "Day": {
                                      "metricKey": "media_value",
                                      "reqMetricKey": "media_value",
                                      "formatRule": "thousands2Decimal",
                                      "isCompare": false,
                                      "nameEn": "Today",
                                      "nameCn": "当天"
                                    }
                                  },
                                }
                              }
                            }
                          ]
                        },
                        {
                          "name": "CommonCol",
                          "className": "",
                          "type": "layout",
                          "style": {},
                          "props": {
                            "w": 8
                          },
                          "children": [
                            {
                              "name": "StudioMetricCardTrend",
                              "className": "dbh-studio-kol-card",
                              "type": "view",
                              "style": {},
                              "props": {
                                "apiDataKey": "kolCardData",
                                "config": {
                                  "metricKey": "roi",
                                  "titleEn": "Media Value ROI",
                                  "titleCn": "投入产出比",
                                  "rainbowKey": "Media Value ROI",
                                  "formatRule": "percent2Decimal",
                                  "isRightCard": true,
                                  "trendConfig": {
                                    "Day": {
                                      "metricKey": "roi",
                                      "reqMetricKey": "roi",
                                      "formatRule": "percent2Decimal",
                                      "isCompare": false,
                                      "nameEn": "Today",
                                      "nameCn": "当天"
                                    }
                                  },
                                }
                              }
                            }
                          ]
                        }
                      ]
                    }
                  ],
                }
              ],
            },
            {
              name: 'KolTableService',
              props: {
                api: '/api/v2/dashboard/studio/game/kol/metric/list',
                extraParams: {
                  "metrics": [
                    "total_cost",
                    "media_value",
                    "roi",
                    "total_views",
                    "cpkv",
                    "likes_rate",
                    "engagement_rate"
                  ],
                  "order_by": [{
                    "by": "total_cost",
                    "order": "desc"
                  }],
                  "group_by": [
                    "campaign_name"
                  ],
                  "page_index": 1,
                  "page_size": 5,
                  "logical_flag": "show_total",
                },
                expandExtraParams: {
                  "group_by": [
                    "campaign_name",
                    "channel_name",
                    "channel_region",
                    "channel_picture",
                    "platform",
                    "content",
                    "format",
                    "region",
                    "country_code"
                  ],

                },
                percentKeys: ['total_cost', 'media_value'],
              },
              children: [
                {
                  "name": "KolTable",
                  "props": {
                    "style": { marginTop: 20 },
                    "defaultFixedColumns": ['{{campaign_name}}'],
                    "componentMetrics": [
                      {
                        "metricKey": "{{campaign_name}}",
                        "widthEn": 250,
                        "widthCn": 250,
                        "nameEn": "Campaign",
                        "nameCn": "活动",
                        "valueFormat": "int",
                        "renderMap": 'getCampaignRender'
                      },
                      {
                        "metricKey": "{{content}}",
                        "widthEn": 200,
                        "widthCn": 200,
                        "nameEn": "Content",
                        "nameCn": "内容",
                        "rainbowKey": "Content",
                        "align": 'left'
                      },
                      {
                        "metricKey": "{{format}}",
                        "widthEn": 140,
                        "widthCn": 140,
                        "nameEn": "Format",
                        "nameCn": "格式",
                        "align": 'left'
                      },
                      {
                        "metricKey": "{{metrics.total_cost.value}}",
                        "reqMetricKey": "total_cost",
                        "widthEn": 200,
                        "widthCn": 200,
                        "nameEn": "Cost($)",
                        "nameCn": "总花费($)",
                        "valueFormat": "thousands2Decimal",
                        "sort": true,
                        "align": 'right',
                        "renderMap": 'getProgressRender',
                        "percentKey": '{{metrics.total_cost.percent}}'
                      },
                      {
                        "metricKey": "{{metrics.media_value.value}}",
                        "reqMetricKey": "media_value",
                        "widthEn": 200,
                        "widthCn": 200,
                        "nameEn": "Media Value($)",
                        "nameCn": "媒体价值($)",
                        "valueFormat": "thousands2Decimal",
                        "sort": true,
                        "align": 'right',
                        "renderMap": 'getProgressRender',
                        "percentKey": '{{metrics.media_value.percent}}'
                      },
                      {
                        "metricKey": "{{metrics.roi.value}}",
                        "reqMetricKey": "roi",
                        "widthEn": 200,
                        "widthCn": 200,
                        "nameEn": "Media Value ROI",
                        "nameCn": "投入产出比",
                        "rainbowKey": "Media Value ROI",
                        "valueFormat": "percent2Decimal",
                        "sort": true,
                        "align": 'right',
                      },
                      {
                        "metricKey": "{{metrics.total_views.value}}",
                        "reqMetricKey": "total_views",
                        "widthEn": 150,
                        "widthCn": 150,
                        "nameEn": "Views",
                        "nameCn": "观看量",
                        "valueFormat": "thousandsInit",
                        "sort": true,
                        "align": 'right'
                      },
                      {
                        "metricKey": "{{metrics.cpkv.value}}",
                        "reqMetricKey": "cpkv",
                        "widthEn": 150,
                        "widthCn": 200,
                        "nameEn": "CPKV($)",
                        "nameCn": "每千次观看花费($)",
                        "rainbowKey": "CPKV",
                        "valueFormat": "thousands2Decimal",
                        "sort": true,
                        "align": 'right'
                      },
                      {
                        "metricKey": "{{metrics.likes_rate.value}}",
                        "reqMetricKey": "likes_rate",
                        "widthEn": 150,
                        "widthCn": 150,
                        "nameEn": "Likes%",
                        "nameCn": "点赞率",
                        "rainbowKey": "Likes%",
                        "valueFormat": "percent2Decimal",
                        "sort": true,
                        "align": 'right'
                      },
                      {
                        "metricKey": "{{metrics.engagement_rate.value}}",
                        "reqMetricKey": "engagement_rate",
                        "widthEn": 180,
                        "widthCn": 180,
                        "nameEn": "Engagement%",
                        "nameCn": "互动率",
                        "rainbowKey": "Engagement%",
                        "valueFormat": "percent2Decimal",
                        "sort": true,
                        "align": 'right'
                      },
                    ]
                  }
                },
              ]
            }
          ]
        }
      ]
    }
  ]
};
